export default __webpack_public_path__ + "static/media/close-purple.527c76d3.svg";